import React from 'react';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import { useTranslation } from 'react-i18next';

import { MEDIA_POOL_SOURCE_MODES } from '../../constants';
import MediaSourceSwitchButton from './MediaSourceSwitchButton';

import scss from './MediaSourceSwitch.module.scss';

function MediaSourceSwitch({ value, onChange }) {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper}>
      <span className={scss.label} id='media-pool-source-label'>
        {t('alternativeMediaBy')}
      </span>

      <div className={scss.group} role='radiogroup' aria-labelledby='media-pool-source-label'>
        <MediaSourceSwitchButton
          icon={ImageOutlinedIcon}
          label={t('sourceByMedia')}
          isActive={value === MEDIA_POOL_SOURCE_MODES.MEDIA}
          onClick={() => onChange(MEDIA_POOL_SOURCE_MODES.MEDIA)}
        />

        <MediaSourceSwitchButton
          icon={TextFieldsOutlinedIcon}
          label={t('sourceByMessage')}
          isActive={value === MEDIA_POOL_SOURCE_MODES.MESSAGE}
          onClick={() => onChange(MEDIA_POOL_SOURCE_MODES.MESSAGE)}
        />
      </div>
    </div>
  );
}

export default MediaSourceSwitch;
